import React from 'react'
import "./ProjectTasks.css"

export default function SkeletonUIHeader() {
  return (  
 <div className='skeleton-wrapper'> 
      <div style={{display:"flex", justifyContent:'Space-between', width:"100%",top:"-1em"}}>
      <div className="skeleton skeleton-button" />
      <div style={{display:"flex", gap:"1rem"}}>
      <div className="skeleton skeleton-button" style={{width:"2.5em",borderRadius:"8rem"}}/>
      <div className="skeleton skeleton-button" />
      </div>
      </div>
      <div style={{display:"flex", justifyContent:'Space-between', width:"100%",top:"-1em"}}>
      <div className='skeleton skeleton-text medium'/> 
      <div className="skeleton skeleton-button" style={{top:'-1.3em'}} />
      </div>
    </div>
      )
    }